<div *ngIf="data.success==true">
  <div class="col-12 text-center">
    <div class="text-success m-2">
      <em class="fa fa-check-circle font-size-25px"></em>
    </div>
    <p class="text-sucess" [ngClass]="{'mb-1' : data.trnID != null}" innerHTML="{{textMessage}}"></p>
    <div class="" *ngIf="data.trnID != null">
      <h6 class="text-center"> Transaction Reference Number is <strong>{{trnID}}</strong> </h6>
    </div>
    <button class="btn btnc" (click)="close()"><em class="fa fa-thumbs-up fa-fw"></em> {{'ok'|translate}}</button>
  </div>
</div>
<div *ngIf="data.secondary==true">
  <div class="col-12 text-center">
    <div class="text-secondary  m-2">
      <em class="fa fa-exclamation-triangle font-size-25px"></em>
    </div>
    <p [ngClass]="{'mb-1' : data.trnID != null}">{{textMessage}}</p>
    <button class="btn btn-cancel" (click)="close()"><em class="fa fa-thumbs-up fa-fw"></em>
      {{'ok'|translate}}</button>
  </div>
</div>
<div *ngIf="data.error==true">
  <div class="col-12 text-center">
    <div class="text-danger m-2">
      <em class="fa fa-exclamation-triangle font-size-25px"></em>
    </div>
    <p class="text-danger">{{textMessage}}</p>
    <div class="" *ngIf="data.trnID != null">
      <h6 class="text-center"> Transaction Reference Number is <strong>{{trnID}}</strong> </h6>
    </div>
    <button class="btn btnreset btnc" (click)="close()"><em class="fa fa-thumbs-up fa-fw"></em>
      {{'ok'|translate}}</button>
  </div>
</div>

<div *ngIf="data.yesOrNoPopup">
  <div class="col-12 text-center">
    <p [innerHTML]="data.errorMessage"></p>
    <button class="btn btnreset m-2" (click)="close()"><em class="fa fa-times fa-fw"></em> {{'No' |
      translate}}</button>
    <button class="btn btnc m-2" (click)="yes()"><em class="fa fa-check fa-fw"></em> {{'Yes' | translate}}</button>

  </div>
</div>

<div *ngIf="data.delete">
  <div class="col-12 text-center">
    <p [innerHTML]="data.confirmMessage"></p>
    <button class="btn btnreset m-2" (click)="close()"><em class="fa fa-times fa-fw"></em> {{'No' |
      translate}}</button>
    <button class="btn btnc m-2" (click)="yesScreen()"><em class="fa fa-check fa-fw"></em> {{'Yes' |
      translate}}</button>

  </div>
</div>


<div *ngIf="data.infoMessage==true">
  <div class="col-12 text-center">
    <div class="text-success m-2">
      <em class="fa fa-info-circle font-size-25px"></em>
    </div>
    <p class="text-sucess" [ngClass]="{'mb-1' : data.trnID != null}" innerHTML="{{textMessage}}"></p>
    <button class="btn btnc" (click)="close()"><em class="fa fa-thumbs-up fa-fw"></em> {{'ok'|translate}}</button>
  </div>
</div>


<div *ngIf="data.message=='SUCCESS'">
  <div class="col-12 text-center">
    <div class="text-success m-2">
      <em class="fa fa-check-circle font-size-25px"></em>
    </div>
    <p class="text-sucess" [ngClass]="{'mb-1' : data.trnID != null}" innerHTML="{{data.errorMessage}}"></p>
    <div class="" *ngIf="data.trnID != null">
      <h6 class="text-center"> Transaction Reference Number is <strong>{{data.trnID}}</strong> </h6>
    </div>
    <button class="btn btnc" (click)="close()"><em class="fa fa-thumbs-up fa-fw"></em> {{'ok'|translate}}</button>
  </div>
</div>



<div *ngIf="data.tokenExpired==true">
  <div class="col-12 text-center">
    <div class="text-warning m-2">
      <em class="fa fa-exclamation-triangle aria-hidden= true font-size-25px"></em>
    </div>
    <p class="text-sucess" [ngClass]="{'mb-1' : data.trnID != null}" innerHTML="{{textMessage}}"></p>
    <div class="" *ngIf="data.trnID != null">
      <h6 class="text-center"> Transaction Reference Number is <strong>{{trnID}}</strong> </h6>
    </div>
    <button class="btn btnc" (click)="close()"><em class="fa fa-thumbs-up fa-fw"></em> {{'ok'|translate}}</button>
  </div>
</div>



<div *ngIf="data.yesNoPopup" class="p-3">
  <div class="col-12 ">
    <p [innerHTML]="data.errorMessage"></p>

    <div class="col-md-12 col-lg-12 col-xl-12 col-xs-12 col-sm-12 row mb-2 mt-3">
      <div class="col-12 col-md-4 col-form-div text-right mb-2"><strong>{{'Comments' |translate}}<span
            class="text-danger">*</span>&nbsp;&nbsp;:</strong>
      </div>
      <div class="col-12 col-md-8 mb-2 ">
        <textarea class="form-control" [(ngModel)]="reasoninput" (ngModelChange)="handleEnteredValue()"
          placeholder="{{'Comments' |translate}}" col="100" row="100"></textarea>
        <div><span *ngIf="allocationErrorss" class="text-danger">{{'Enter_commentsRequired'|translate}}</span></div>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <button class="btn btnreset m-2" (click)="CLOSE()"><em class="fa fa-times fa-fw"></em> {{'No' |
        translate}}</button>
      <button class="btn btnc m-2" (click)="YES()"><em class="fa fa-check fa-fw"></em> {{'Yes' | translate}}</button>
    </div>

  </div>
</div>



<div *ngIf="data.termsView">
  <div class="col-12">
   <p class="text-center"> Terms and Conditions will come soon</p>
   <div class="">
   <mat-checkbox [(ngModel)]="termsChecked">
   {{ 'termsAndCondition' | translate}}
   </mat-checkbox>
  </div>
  <div class="text-center mt-2">
    <button class="btn btnPC" *ngIf="termsChecked" (click)="close()"><em class="fa fa-thumbs-up fa-fw"></em> {{'submit'|translate}}</button>
  </div>
 </div>
</div>
<div *ngIf="data.notAllow==true">
  <div class="col-12 text-center">
   
    <div>
      <h6 class="text-center"> Please note that the configured fields will be lost and will not be able to be reversed.</h6>
    </div>
    <button class="btn btnc" (click)="close()"><em class="fa fa-thumbs-up fa-fw"></em> {{'ok'|translate}}</button>
  </div>
</div>

<div *ngIf="data.dateOverLap==true">
  <div class="col-12 text-center">
    <div class="text-danger m-2">
      <em class="fa fa-exclamation-triangle font-size-25px"></em>
    </div>

    <div >
      <h6 class="text-center">{{data.errorMessage}}</h6>
    </div>
    <button class="btn btnreset btnc" (click)="close()"><em class="fa fa-thumbs-up fa-fw"></em>
      {{'ok'|translate}}</button>
  </div>
</div>